<div class="app-filter-wrapper">
  <!-- Filter Trigger Pill -->
  <div
    class="app-filter-pill"
    [class.app-filter-pill--active]="isFilterApplied"
    [class.app-filter-pill--open]="isOpen"
    [class.app-filter-pill--disabled]="disabled"
    (click)="toggleDropdown($event)"
  >
    <!-- Plus / Cross Icon -->
    <span
      class="app-filter-pill__icon"
      [class.app-filter-pill__icon--active]="isFilterApplied"
      (click)="isFilterApplied && handleCancelFilter($event)"
    >
      <svg width="15" height="15" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="10" cy="10" r="9" stroke="currentColor" stroke-width="1.8"/>
        <path d="M10 5.5V14.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
        <path d="M5.5 10H14.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
      </svg>
    </span>

    <!-- Label -->
    <span class="app-filter-pill__label">
      {{ resolvedLabel }}
      <span *ngIf="isFilterApplied" class="app-filter-pill__value">
        {{ equalitySymbol }} {{ currencySymbol }}{{ displayAmount }}
      </span>
    </span>
  </div>

  <!-- Popover Menu -->
  <div *ngIf="isOpen" class="app-filter-popover" (click)="$event.stopPropagation()">
    <div class="app-filter-popover__header">
      <p class="app-filter-popover__title">Filter by {{ labelText }}</p>
    </div>

    <!-- Equality Selector -->
    <div class="app-filter-popover__field">
      <select
        class="app-filter-popover__select"
        [(ngModel)]="tempEqualityType"
      >
        <option *ngFor="let opt of equalityOptions" [value]="opt.value">
          {{ opt.label }}
        </option>
      </select>
    </div>

    <!-- Amount Input -->
    <div class="app-filter-popover__amount-row">
      <span class="app-filter-popover__currency">{{ currencySymbol }}</span>
      <input
        type="number"
        [(ngModel)]="tempAmount"
        placeholder="0.00"
        class="app-filter-popover__amount-input"
        min="0"
        step="0.01"
      />
    </div>

    <!-- Action Buttons -->
    <div class="app-filter-popover__actions">
      <app-primary-button
        label="APPLY"
        size="medium"
        [fullWidth]="true"
        (btnClick)="applyFilter($event)"
        [disabled]="!tempAmount || !tempAmount.trim()"
      ></app-primary-button>
    </div>
  </div>
</div>
